module.exports = __webpack_public_path__ + "img/Starbucks_GlobalAcademy_lockup_horizontal_FINAL-01_(1).acc5fc85.svg";